import { DocType } from "../../sid";
import { ID } from "../../../models/ID";

export class RequestedDoc {
  documentType: DocType;
  displayName: string;
  documentURI?: string;
  createdDocument?: ID;
  documentFetch?: 'started' | 'failed' | 'success'
  faceVerification?: 'started' | 'failed' | 'success'
  documentCreation?: 'started' | 'failed' | 'success'

}
